import { Link } from "react-router-dom";
import { SEO, OrganizationJsonLd } from "@/components/SEO";

const categories = [
  { label: "NEW ARRIVALS", to: "/new" },
  { label: "TEES", to: "/collection?category=tees" },
  { label: "SWEATS", to: "/collection?category=sweats" },
  { label: "HEADWEAR", to: "/collection?category=headwear" },
  { label: "OUTERWEAR", to: "/collection?category=outerwear" },
  { label: "KNITS", to: "/collection?category=knits" },
  { label: "TOPS & SHIRTS", to: "/collection?category=tops" },
  { label: "SHORTS", to: "/collection?category=shorts" },
  { label: "PANTS", to: "/collection?category=pants" },
  { label: "DENIM", to: "/collection?category=denim" },
  { label: "ACCESSORIES", to: "/collection?category=accessories" },
  { label: "ARCHIVE", to: "/collection" },
  { label: "SUPPORT", to: "/contact" },
  { label: "ACCOUNT", to: "/profile" },
  { label: "LEGAL", to: "/terms-of-service" },
];

const Index = () => {
  return (
    <div className="h-screen w-screen overflow-hidden bg-black text-gray-500 flex flex-col relative">
      <SEO url="/" />
      <OrganizationJsonLd />


      <aside className="flex-1 min-h-0 flex flex-col px-6 py-6 relative z-10">
        {/* Logo */}
        <Link
          to="/"
          className="font-display text-3xl md:text-4xl tracking-wider text-gray-500 hover:text-gray-300 transition-colors mb-4"
          lang="ja"
        >
          ユニオン
        </Link>

        {/* Categories */}
        <nav aria-label="Categories" className="flex flex-col gap-2">
          {categories.map((c) => (
            <Link
              key={c.label}
              to={c.to}
              className="text-[11px] md:text-xs uppercase tracking-widest leading-tight hover:text-red-500 transition-colors w-fit py-[2px]"
            >
              {c.label}
            </Link>
          ))}
        </nav>

        {/* Bottom-left utility links */}
        <nav aria-label="Utility" className="mt-auto pt-4 flex gap-4 text-[11px] md:text-xs uppercase tracking-widest leading-tight text-red-500">
          <Link to="/search" className="hover:text-white transition-colors py-[2px]">
            Search
          </Link>
          <Link to="/cart" className="hover:text-white transition-colors py-[2px]">
            Bag
          </Link>
        </nav>

        {/* Footer / copyright */}
        <div className="pt-1 text-[10px] uppercase tracking-widest text-gray-600">
          © {new Date().getFullYear()} Union Collection
        </div>
      </aside>

      {/* Obon date marker */}
      <div className="absolute bottom-4 right-6 text-[10px] uppercase tracking-widest text-gray-500 z-10">
        Obon 8.13
      </div>
    </div>
  );
};

export default Index;
